import {assert} from 'Asserts';
import {sum} from 'BenchlingUtil';

export function mean(values: Array<number>): number {
  assert(values.length > 0, "Can't calculate mean on empty data");
  return sum(values) / values.length;
}

export function variance(values: Array<number>): number {
  assert(values.length > 1, `Can't calculate sample variance on ${values.length} values`);
  const xMean = mean(values);
  return sum(values.map((x) => (x - xMean) ** 2)) / (values.length - 1);
}

export function standardDeviation(values: Array<number>): number {
  assert(values.length > 1, `Can't calculate sample standard deviation on ${values.length} values`);
  return Math.sqrt(variance(values));
}

export function standardError(values: Array<number>): number {
  assert(values.length > 1, `Can't calculate standard error of the sample mean on ${values.length} values`);
  return standardDeviation(values) / Math.sqrt(values.length);
}
